import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";

export default function ReferralRedirect() {
    const { code } = useParams();
    const normalised = (code || "").trim().toUpperCase().slice(0, 32);

    useEffect(() => {
        if (normalised) {
            try {
                localStorage.setItem("footsie_referral_code", normalised);
            } catch (_e) {
                // localStorage may be unavailable (private mode); the query param below is enough.
            }
        }
    }, [normalised]);

    if (!normalised) return <Navigate to="/register" replace />;
    return <Navigate to={`/register?ref=${encodeURIComponent(normalised)}`} replace />;
}
